<!-- Standalone mode: full RANA page chrome -->
<ng-container *ngIf="!embedded; else embeddedTpl">
    <div class="section over-hide">
        <div class="section padding-top-120 padding-top-mob-nav section-background-rana">
            <div class="section-1400 pt-xl-4">
                <div class="container-fluid padding-top-40">

                    <!-- Event Not Found -->
                    <div class="row justify-content-center" *ngIf="!eventTitle">
                        <div class="col-md-6">
                            <div class="card border-0 landing-shadow-4">
                                <div class="card-body text-center p-5">
                                    <i class="uil uil-exclamation-triangle size-40 text-danger"></i>
                                    <h5 class="mt-3">Event Not Found</h5>
                                    <p class="text-muted">The event you are looking for does not exist or has been removed.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- Event Loaded -->
                    <div class="row justify-content-center" *ngIf="eventTitle && event">
                        <div class="col-lg-8">
                            <!-- Title card (standalone only) -->
                            <div class="card border-0 landing-shadow-4 mb-4">
                                <div class="card-body p-4 text-center">
                                    <i class="uil uil-calendar-alt size-40 color-primary"></i>
                                    <h5 class="mt-3 mb-0 color-primary">{{ event.title }}</h5>
                                </div>
                            </div>
                            <ng-container *ngTemplateOutlet="formCards"></ng-container>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</ng-container>

<!-- Embedded mode: cards only, no page chrome or title card -->
<ng-template #embeddedTpl>
    <ng-container *ngIf="event">
        <ng-container *ngTemplateOutlet="formCards"></ng-container>
    </ng-container>
</ng-template>

<!-- ===== Shared form cards ===== -->
<ng-template #formCards>

    <!-- Event Closed / Not Open -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="eventStatus && eventStatus !== 'OPEN'">
        <div class="card-body text-center p-4">
            <p class="text-muted mb-0">Registration for this event is currently closed.</p>
        </div>
    </div>

    <!-- Readonly — Payment Completed (LOCAL) -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="step === 'readonly' && existingRegistration && !isConferenceEvent">
        <div class="card-body p-4">
            <h5 class="color-primary mb-3">
                <i class="uil uil-check-circle mr-1 text-success"></i>
                Welcome back, {{ verifiedUserName }}!
            </h5>
            <div class="alert alert-success">
                <i class="uil uil-check-circle mr-1"></i>
                <strong>Registration Complete</strong> — Your registration and payment are confirmed.
            </div>
            <h6 class="mb-3">Your Registration Details</h6>
            <div class="border rounded p-3">
                <div class="row">
                    <div class="col-md-4 mb-2" *ngIf="existingRegistration.adults">
                        <strong>Adults:</strong> {{ existingRegistration.adults }}
                    </div>
                    <div class="col-md-4 mb-2" *ngIf="existingRegistration.children">
                        <strong>{{ childrenCountLabel }}:</strong> {{ existingRegistration.children }}
                    </div>
                    <div class="col-md-4 mb-2" *ngIf="existingRegistration.seniors">
                        <strong>Senior Citizens:</strong> {{ existingRegistration.seniors }}
                    </div>
                </div>
                <div *ngIf="existingRegistration.childAges" class="mb-2">
                    <strong>Child Ages:</strong> {{ existingRegistration.childAges }}
                </div>
                <div *ngFor="let ans of existingRegistration.formAnswers" class="mb-2">
                    <strong>{{ ans.questionLabel }}:</strong> {{ (ans.selectedLabels || []).join(', ') }}
                </div>
                <div *ngIf="existingRegistration.donationAmt && +existingRegistration.donationAmt > 0" class="mb-2">
                    <strong>Donation:</strong> {{ +existingRegistration.donationAmt | currency:'USD' }}
                </div>
                <hr>
                <div class="row">
                    <div class="col-md-6 mb-2">
                        <strong>Payment Method:</strong> {{ getPaymentTypeLabel(existingRegistration.paymentType) }}
                    </div>
                    <div class="col-md-6 mb-2">
                        <strong>Status:</strong>
                        <span class="rana-badge rana-badge-success ml-1">{{ getPaymentStatusLabel() }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- Readonly — Booking Completed (CONFERENCE) -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="step === 'readonly' && existingBooking && isConferenceEvent">
        <div class="card-body p-4">
            <h5 class="color-primary mb-3">
                <i class="uil uil-check-circle mr-1 text-success"></i>
                Welcome back, {{ verifiedUserName }}!
            </h5>
            <div class="alert alert-success">
                <i class="uil uil-check-circle mr-1"></i>
                <strong>Registration Confirmed</strong> — Your registration and payment are confirmed.
            </div>
            <h6 class="mb-3">Your Event Details</h6>
            <div class="border rounded p-3">
                <p class="mb-2"><strong>Registration:</strong> {{ getBookingOptionsSummary(existingBooking) }}</p>
                <p class="mb-2" *ngIf="existingBooking.attending"><strong>Attending:</strong> {{ existingBooking.attending === 'YES' ? 'Yes' : 'No' }}</p>
                <p class="mb-2" *ngFor="let ans of existingBooking.formAnswers"><strong>{{ ans.questionLabel }}:</strong> {{ (ans.selectedLabels || []).join(', ') }}</p>
                <p class="mb-2" *ngIf="existingBooking.totalAmount"><strong>Total:</strong> {{ existingBooking.totalAmount | currency:'USD' }}</p>
                <p class="mb-2" *ngIf="existingBooking.donationAmt && +existingBooking.donationAmt > 0">
                    <strong>Donation:</strong> {{ +existingBooking.donationAmt | currency:'USD' }}
                </p>
                <hr>
                <p class="mb-1"><strong>Payment Method:</strong> {{ getPaymentTypeLabel(existingBooking.paymentType) }}</p>
                <p class="mb-0"><strong>Status:</strong> <span class="rana-badge rana-badge-success ml-1">Payment Confirmed</span></p>
            </div>
        </div>
    </div>

    <!-- Step 1: Registration / Booking Form -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="eventStatus === 'OPEN' && step === 'register'">
        <div class="card-body p-4">

            <h6 class="mb-3">Register for Event</h6>
            <p class="text-muted">Please enter your registered email to continue.</p>

            <div class="alert alert-warning" *ngIf="!isConferenceEvent && existingRegistration && existingRegistration.status !== 'PAYMENT_CONFIRMED'">
                <i class="uil uil-exclamation-triangle mr-1"></i>
                <strong>Payment Pending</strong> — You already registered. We've loaded your previous details — update and resubmit.
            </div>
            <div class="alert alert-warning" *ngIf="isConferenceEvent && existingBooking && existingBooking.status !== 'PAYMENT_CONFIRMED'">
                <i class="uil uil-exclamation-triangle mr-1"></i>
                <strong>Payment Pending</strong> — You already submitted an event registration. We've loaded your previous selection — update and resubmit.
            </div>

            <form class="nfr-form-standard" [formGroup]="registrationForm">
                <div class="row">
                    <div class="col-12">
                        <label>Email Address</label>
                        <div class="input-group">
                            <input type="email"
                                   formControlName="email"
                                   class="form-control"
                                   placeholder="Enter your registered email"
                                   (blur)="onEmailBlur()"
                                   [ngClass]="{'is-invalid': registrationForm.get('email')?.touched && registrationForm.get('email')?.invalid}">
                            <div class="input-group-append">
                                <button type="button"
                                        class="btn btn-blue"
                                        [disabled]="emailVerifying"
                                        (click)="onEmailBlur()"
                                        aria-label="Verify email">
                                    <i class="uil uil-search"></i>
                                </button>
                            </div>
                        </div>
                        <small class="text-success d-block mt-1" *ngIf="verifiedUserName && !errorMessage">
                            <i class="uil uil-check-circle mr-1"></i>
                            Verified — Welcome, {{ verifiedUserName }}!
                        </small>
                        <div class="invalid-feedback d-block" *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.errors?.['required']">
                            Email is required.
                        </div>
                        <div class="invalid-feedback d-block" *ngIf="registrationForm.get('email')?.touched && registrationForm.get('email')?.errors?.['email']">
                            Please enter a valid email address.
                        </div>
                        <small class="text-danger d-block mt-1" *ngIf="errorMessage && !verifiedUserName">
                            <i class="uil uil-exclamation-circle mr-1"></i>
                            {{ errorMessage }}
                        </small>
                    </div>
                </div>

                <!-- ===== Quick Sign Up Form ===== -->
                <div class="mt-3 p-3 border rounded bg-light" *ngIf="showQuickSignup && !verifiedUserId" [formGroup]="quickSignupForm">
                    <h6 class="mb-3 color-primary"><i class="uil uil-user-plus mr-1"></i>Quick Sign Up</h6>
                    <p class="text-muted small mb-3">New here? Fill in the details below to create your account and continue with registration.</p>
                    <div class="row">
                        <div class="col-md-6 mb-2">
                            <label>First Name <span class="text-danger">*</span></label>
                            <input type="text" formControlName="firstName" class="form-control" placeholder="First Name"
                                   [ngClass]="{'is-invalid': quickSignupForm.get('firstName')?.touched && quickSignupForm.get('firstName')?.invalid}">
                            <div class="invalid-feedback">First name is required and can only contain letters.</div>
                        </div>
                        <div class="col-md-6 mb-2">
                            <label>Last Name <span class="text-danger">*</span></label>
                            <input type="text" formControlName="lastName" class="form-control" placeholder="Last Name"
                                   [ngClass]="{'is-invalid': quickSignupForm.get('lastName')?.touched && quickSignupForm.get('lastName')?.invalid}">
                            <div class="invalid-feedback">Last name is required and can only contain letters.</div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-4 mb-2">
                            <label>Phone <span class="text-danger">*</span></label>
                            <input type="tel" formControlName="phone" class="form-control" placeholder="Phone Number"
                                   [ngClass]="{'is-invalid': quickSignupForm.get('phone')?.touched && quickSignupForm.get('phone')?.invalid}">
                            <div class="invalid-feedback">Please enter a valid phone number (digits only, at least 7).</div>
                        </div>
                        <div class="col-md-4 mb-2">
                            <label>State <span class="text-danger">*</span></label>
                            <input type="text" formControlName="state" class="form-control" placeholder="State"
                                   [ngClass]="{'is-invalid': quickSignupForm.get('state')?.touched && quickSignupForm.get('state')?.invalid}">
                            <div class="invalid-feedback">State is required and can only contain letters.</div>
                        </div>
                        <div class="col-md-4 mb-2">
                            <label>City <span class="text-danger">*</span></label>
                            <input type="text" formControlName="city" class="form-control" placeholder="City"
                                   [ngClass]="{'is-invalid': quickSignupForm.get('city')?.touched && quickSignupForm.get('city')?.invalid}">
                            <div class="invalid-feedback">City is required and can only contain letters.</div>
                        </div>
                    </div>
                    <div class="mt-2">
                        <button type="button" class="btn btn-success" (click)="submitQuickSignup()">
                            <i class="uil uil-check mr-1"></i>Sign Up & Continue
                        </button>
                    </div>
                </div>

                <!-- ===== LOCAL registration fields ===== -->
                <ng-container *ngIf="!isConferenceEvent">
                    <div class="row mt-3">
                        <div class="col-md-4">
                            <label>Adults<ng-container *ngIf="isPaidEvent && unitFee('adults') > 0"> — {{ unitFee('adults') | currency:'USD' }} each</ng-container></label>
                            <input type="number" formControlName="adults" min="0" class="form-control">
                        </div>
                        <div class="col-md-4">
                            <label>{{ childrenCountLabel }}<ng-container *ngIf="isPaidEvent && unitFee('children') > 0"> — {{ unitFee('children') | currency:'USD' }} each</ng-container></label>
                            <input type="number" formControlName="children" min="0" class="form-control">
                            <small class="text-muted d-block mt-1" *ngIf="hasChildAgeLimitRule">
                                Ages {{ event?.childAgeMin || 5 }} to {{ event?.childAgeLimit }}
                            </small>
                        </div>
                        <div class="col-md-4">
                            <label>Senior Citizens<ng-container *ngIf="isPaidEvent && unitFee('seniors') > 0"> — {{ unitFee('seniors') | currency:'USD' }} each</ng-container></label>
                            <input type="number" formControlName="seniors" min="0" class="form-control">
                        </div>
                    </div>
                    <div class="row mt-2" *ngIf="hasChildAgeLimitRule">
                        <div class="col-12">
                            <label>Child Ages (Optional, comma separated)</label>
                            <input type="text" formControlName="childAges" class="form-control" [placeholder]="childAgesPlaceholder">
                            <small class="text-muted d-block mt-1">This field is optional and does not affect amount calculation.</small>
                        </div>
                    </div>
                    <div class="row mt-3">
                        <div class="col-md-4">
                            <label>Donation Amount (Optional)</label>
                            <input type="number" min="0" step="0.01" formControlName="donationAmt" class="form-control" placeholder="Enter donation">
                        </div>
                    </div>
                    <div class="mt-3" *ngIf="isPaidEvent">
                        <div class="rana-fee-breakdown mb-2" *ngIf="feeLines.length > 0 || getDonationAmount() > 0">
                                <div class="d-flex justify-content-between small" *ngFor="let line of feeLines; trackBy: trackFeeLine">
                                    <span>{{ line.label }} <span class="text-muted">{{ line.count }} &times; {{ line.unitPrice | currency:'USD' }}</span></span>
                                    <span>{{ line.subtotal | currency:'USD' }}</span>
                                </div>
                                <div class="d-flex justify-content-between small" *ngIf="getDonationAmount() > 0">
                                    <span>Donation</span>
                                    <span>{{ getDonationAmount() | currency:'USD' }}</span>
                                </div>
                                <hr class="my-1">
                            </div>
                        <div *ngIf="isDiscountActive() && getDiscountAmount() > 0">
                            <p class="mb-1">Total: {{ (getFeesSubtotal() + getDonationAmount()) | currency:'USD' }}</p>
                            <p class="mb-1 text-success">{{ event?.discountLabel || 'Early Bird Discount' }}: -{{ getDiscountAmount() | currency:'USD' }}</p>
                            <h6 class="color-primary mb-0"><strong>Amount Due:</strong> {{ calculateAmountDue() | currency:'USD' }}</h6>
                        </div>
                        <h6 class="color-primary" *ngIf="!(isDiscountActive() && getDiscountAmount() > 0)"><strong>Amount Due:</strong> {{ calculateAmountDue() | currency:'USD' }}</h6>
                    </div>
                    <app-question-fields *ngIf="registrationQuestions.length > 0"
                                         [questions]="registrationQuestions"
                                         [(answers)]="localFormAnswers"
                                         [showErrors]="localSubmitAttempted"
                                         idPrefix="pubLocQ"></app-question-fields>

                    <div class="form-group mb-3 mt-3" *ngIf="isPaidEvent">
                        <label class="mb-2">Payment Method</label>
                        <div class="form-check" *ngIf="isStripeEnabled()">
                            <input type="radio" id="regPayStripe" value="stripe" formControlName="paymentType">
                            <label class="radio mb-0 font-weight-600 size-15" for="regPayStripe">Pay with Card</label>
                        </div>
                        <div class="form-check mt-1">
                            <input type="radio" id="regPayZelle" value="zelle" formControlName="paymentType">
                            <label class="radio mb-0 font-weight-600 size-15" for="regPayZelle">Pay with Zelle</label>
                            <small class="text-muted d-block ml-4" style="position: static;" *ngIf="event?.zellePaymentDetails">Send to: {{ event?.zellePaymentDetails }}</small>
                        </div>
                        <div class="form-check mt-1">
                            <input type="radio" id="regPayCheck" value="check" formControlName="paymentType">
                            <label class="radio mb-0 font-weight-600 size-15" for="regPayCheck">Pay by Check</label>
                            <small class="text-muted d-block ml-4" style="position: static; white-space: pre-line;" *ngIf="event?.checkPaymentDetails">Pay to the order of: {{ event?.checkPaymentDetails }}</small>
                        </div>
                        <div class="form-check mt-1">
                            <input type="radio" id="regPayLater" value="later" formControlName="paymentType">
                            <label class="radio mb-0 font-weight-600 size-15" for="regPayLater">Pay Later</label>
                        </div>
                    </div>
                    <div class="row mt-2" *ngIf="isOfflinePayment">
                        <div class="col-md-6">
                            <label>{{ paymentReferenceLabel }} (Optional)</label>
                            <input type="text" formControlName="paymentReference" class="form-control" [placeholder]="'Enter ' + paymentReferenceLabel.toLowerCase()">
                            <small class="text-muted d-block mt-1">You can submit now and provide this later.</small>
                        </div>
                    </div>
                    <small class="text-muted d-block mt-2" *ngIf="selectedPaymentType === 'stripe'">
                        You will be redirected to Stripe after saving this registration.
                    </small>
                    <div class="mt-3">
                        <button type="button" class="btn btn-primary" (click)="submitRegistration()">{{ paymentSubmitLabel }}</button>
                    </div>
                </ng-container>
            </form>

            <!-- ===== CONFERENCE booking fields ===== -->
            <ng-container *ngIf="isConferenceEvent && verifiedUserId">
                <p class="mb-2 text-danger" *ngIf="isDiscountActive() && hasDiscountValue()">
                    To get {{ event?.discountType === 'PERCENT' ? (event?.discountValue + '%') : ('$' + event?.discountValue) }} discount, Register before {{ formatDiscountEndDate(event?.discountEndDate) }} with full payment
                </p>
                <div class="table-responsive mt-3 mb-2 rana-table-card"
                     [class.border]="showBookingOptionsError"
                     [class.border-danger]="showBookingOptionsError"
                     [class.rounded]="showBookingOptionsError">
                    <table class="table rana-table mb-0">
                        <thead>
                        <tr>
                            <th style="min-width:180px">Options</th>
                            <th style="width:90px">Price</th>
                            <th style="width:110px">Quantity</th>
                            <th style="width:110px">Subtotal</th>
                        </tr>
                        </thead>
                        <tbody>
                        <ng-container *ngFor="let group of groupedTicketOptions">
                            <tr *ngIf="group.sectionLabel" class="table-secondary">
                                <td colspan="4" class="font-weight-bold py-1">{{ group.sectionLabel }}</td>
                            </tr>
                            <tr *ngFor="let opt of group.options">
                                <td>
                                    {{ opt.label }}
                                    <span *ngIf="opt.required" class="text-danger" title="Required">&nbsp;*</span>
                                    <span *ngIf="opt.subText" class="label-subtext">{{ opt.subText }}</span>
                                </td>
                                <td>{{ opt.paid !== false ? ('$' + opt.price) : '—' }}</td>
                                <td>
                                    <input type="number" min="0"
                                           class="form-control form-control-sm"
                                           [(ngModel)]="bookingQuantities[opt.optionId!]">
                                </td>
                                <td>{{ opt.paid !== false ? (((bookingQuantities[opt.optionId!] || 0) * (+opt.price || 0)) | currency:'USD') : '—' }}</td>
                            </tr>
                        </ng-container>
                        </tbody>
                    </table>
                </div>
                <small class="text-danger d-block mb-2" *ngIf="showBookingOptionsError">
                    <i class="uil uil-exclamation-circle mr-1"></i>
                    Please select at least one of the option.
                </small>

                <!-- Legacy events (no registrationQuestions) keep the built-in Yes/No attending radio -->
                <div class="form-group mt-3" *ngIf="usesLegacyAttending">
                    <label class="mb-2 font-weight-bold">Are you attending the conference? <span class="text-danger">*</span></label>
                    <div class="form-check">
                        <input type="radio" id="pubBkAttendYes" [(ngModel)]="bookingAttending" value="YES">
                        <label class="radio mb-0" for="pubBkAttendYes">Yes</label>
                    </div>
                    <div class="form-check mt-1">
                        <input type="radio" id="pubBkAttendNo" [(ngModel)]="bookingAttending" value="NO">
                        <label class="radio mb-0" for="pubBkAttendNo">No</label>
                    </div>
                    <small class="text-danger d-block mt-1" *ngIf="showBookingAttendingError">
                        <i class="uil uil-exclamation-circle mr-1"></i>
                        Please select Yes or No.
                    </small>
                </div>

                <app-question-fields *ngIf="!usesLegacyAttending"
                                     [questions]="registrationQuestions"
                                     [(answers)]="bookingFormAnswers"
                                     [showErrors]="bookingSubmitAttempted"
                                     idPrefix="pubBkQ"></app-question-fields>

                <div class="row mb-3">
                    <div class="col-md-4">
                        <label>Donation (Optional)</label>
                        <input type="number" min="0" step="0.01"
                               [(ngModel)]="bookingDonationAmt"
                               class="form-control form-control-sm">
                    </div>
                </div>

                <div *ngIf="isDiscountActive() && getBookingDiscountAmount() > 0">
                    <p class="mb-1">Total: {{ (getBookingOptionsSubtotal() + (bookingDonationAmt || 0)) | currency:'USD' }}</p>
                    <p class="mb-1 text-success">{{ event?.discountLabel || 'Early Bird Discount' }}: -{{ getBookingDiscountAmount() | currency:'USD' }}</p>
                    <h6 class="color-primary mb-0"><strong>Estimated Total:</strong> {{ calculateBookingTotal() | currency:'USD' }}</h6>
                </div>
                <h6 class="color-primary" *ngIf="!(isDiscountActive() && getBookingDiscountAmount() > 0)"><strong>Estimated Total:</strong> {{ calculateBookingTotal() | currency:'USD' }}</h6>

                <div class="form-group mt-3">
                    <label class="mb-2 font-weight-bold">Payment Method</label>
                    <div class="form-check" *ngIf="isStripeEnabled()">
                        <input type="radio" id="pubBkStripe" [(ngModel)]="bookingPaymentType" value="stripe">
                        <label class="radio mb-0 font-weight-600 size-15" for="pubBkStripe">Pay with Card</label>
                    </div>
                    <div class="form-check mt-1">
                        <input type="radio" id="pubBkZelle" [(ngModel)]="bookingPaymentType" value="zelle">
                        <label class="radio mb-0" for="pubBkZelle">Pay with Zelle</label>
                        <small class="text-muted d-block ml-4" style="position: static;" *ngIf="event?.zellePaymentDetails">Send to: {{ event?.zellePaymentDetails }}</small>
                    </div>
                    <div class="form-check mt-1">
                        <input type="radio" id="pubBkCheck" [(ngModel)]="bookingPaymentType" value="check">
                        <label class="radio mb-0" for="pubBkCheck">Pay by Check</label>
                        <small class="text-muted d-block ml-4" style="position: static; white-space: pre-line;" *ngIf="event?.checkPaymentDetails">Pay to the order of: {{ event?.checkPaymentDetails }}</small>
                    </div>
                    <div class="form-check mt-1">
                        <input type="radio" id="pubBkLater" [(ngModel)]="bookingPaymentType" value="later">
                        <label class="radio mb-0" for="pubBkLater">Pay Later</label>
                    </div>
                </div>
                <div class="row mt-2" *ngIf="bookingPaymentType === 'zelle' || bookingPaymentType === 'check'">
                    <div class="col-md-6">
                        <label>{{ bookingPaymentType === 'check' ? 'Check Number' : 'Zelle Confirmation' }} (Optional)</label>
                        <input type="text" [(ngModel)]="bookingPaymentReference" class="form-control">
                    </div>
                </div>
                <small class="text-muted d-block mt-2" *ngIf="bookingPaymentType === 'stripe'">
                    You will be redirected to Stripe after submitting your registration.
                </small>

                <div class="mt-3">
                    <button type="button" class="btn btn-primary" (click)="submitBooking()">{{ bookingSubmitLabel }}</button>
                </div>
            </ng-container>

        </div>
    </div>

    <!-- Step 2: Confirmation -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="step === 'confirmation'">
        <div class="card-body text-center p-5">
            <i class="uil uil-check-circle size-40 text-success"></i>
            <h5 class="mt-3">{{ isConferenceEvent ? 'Event Registration Submitted!' : 'Registration Successful!' }}</h5>
            <p class="text-muted mt-2">Thank you, {{ verifiedUserName }}. Your {{ isConferenceEvent ? 'event registration' : 'registration' }} has been saved.</p>
            <div class="alert alert-info mt-3" *ngIf="!isConferenceEvent && registrationSummary">
                {{ registrationSummary }}
            </div>
            <div class="alert alert-info mt-3" *ngIf="isConferenceEvent && bookingConfirmationSummary">
                {{ bookingConfirmationSummary }}
            </div>
            <p class="text-muted mt-3 small">
                You will receive a confirmation email shortly.
            </p>
        </div>
    </div>

    <!-- Event Details Card -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="step === 'register' || step === 'readonly'">
        <div class="card-body p-4">
            <h6 class="mb-3 color-primary">Event Details</h6>
            <div class="border rounded p-3 bg-light">
                <div class="row">
                    <div class="col-md-6">
                        <p class="mb-1"><strong>Start:</strong> {{ event?.eventStartDate | date:'mediumDate' }} {{ formatTime(event?.eventStartTime || '') }}</p>
                        <p class="mb-1"><strong>End:</strong> {{ event?.eventEndDate | date:'mediumDate' }} {{ formatTime(event?.eventEndTime || '') }}</p>
                    </div>
                    <div class="col-md-6">
                        <p class="mb-1" *ngIf="event?.eventLocation"><strong>Location:</strong> {{ event?.eventLocation }}</p>
                    </div>
                </div>
                <div *ngIf="event?.eventDescription" class="mt-2 event-description-content">
                    <p class="mb-0" [innerHTML]="event?.eventDescription"></p>
                </div>
                <div class="mt-2" *ngIf="isPaidEvent">
                    <p class="mb-1" *ngIf="event?.eventFeeAdult"><strong>Fee (Adult):</strong> {{ event?.eventFeeAdult | currency:'USD' }}</p>
                    <p class="mb-1" *ngIf="event?.eventFeeChild"><strong>Fee (Child):</strong> {{ event?.eventFeeChild | currency:'USD' }}</p>
                    <p class="mb-1" *ngIf="event?.eventFeeSeniorCitizen"><strong>Fee (Senior):</strong> {{ event?.eventFeeSeniorCitizen | currency:'USD' }}</p>
                    <p class="mb-1 text-danger" *ngIf="isDiscountActive() && hasDiscountValue()">
                        To get {{ event?.discountType === 'PERCENT' ? (event?.discountValue + '%') : ('$' + event?.discountValue) }} discount, Register before {{ formatDiscountEndDate(event?.discountEndDate) }} with full payment
                    </p>
                    <p class="mb-1" *ngIf="hasChildAgeLimitRule">
                        <strong>Child Age Rule:</strong> Children ages {{ event?.childAgeMin || 5 }} to {{ event?.childAgeLimit }} should be entered under Children.
                    </p>
                </div>
            </div>
        </div>
    </div>

    <!-- Guest of Honors (only shown when at least one guest is configured) -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="(step === 'register' || step === 'readonly') && displayEventGuestsOfHonor.length">
        <div class="card-body p-4">
            <h6 class="mb-3 color-primary">Guest of Honors</h6>
            <div #guestSwiperContainer class="section swiper-team padding-bottom-40 swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let member of displayEventGuestsOfHonor">
                        <div class="leader-card text-center">
                            <img *ngIf="member.photoUrl" [src]="member.photoUrl" [alt]="member.name" class="img-fluid w-100 speaker-img">
                            <div *ngIf="!member.photoUrl" class="initials-avatar">{{ getInitials(member.name) }}</div>
                            <h6 class="mb-0 text-rana-primary mt-2">{{ member.name }}</h6>
                            <small class="text-muted text-sm" *ngIf="member.title">{{ member.title }}</small>
                            <p class="mt-2 text-small" *ngIf="member.shortDescription">{{ member.shortDescription }}</p>
                            <a *ngIf="member.videoUrl" [href]="member.videoUrl" class="glightbox btn btn-dark-primary animated m-2" data-type="video">
                                Watch More <i class="uil uil-video size-22 m-2 pr-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>

    <!-- Featured Speakers (only shown when at least one speaker is configured) -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="(step === 'register' || step === 'readonly') && displayEventSpeakers.length">
        <div class="card-body p-4">
            <h6 class="mb-3 color-primary">Featured Speakers</h6>
            <div #speakerSwiperContainer class="section swiper-team padding-bottom-40 swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let speaker of displayEventSpeakers">
                        <div class="speaker-card">
                            <div class="row">
                                <div class="col-12">
                                    <div class="section p-0">
                                        <img *ngIf="speaker.photoUrl" [src]="speaker.photoUrl" [alt]="speaker.name" class="img-fluid w-100 speaker-img">
                                        <div *ngIf="!speaker.photoUrl" class="initials-avatar initials-avatar-lg">{{ getInitials(speaker.name) }}</div>
                                    </div>
                                    <div class="section clearfix p-3">
                                        <a *ngFor="let tag of speaker.tags" class="tag new w-2 mx-1 mt-1">{{ tag }}</a>
                                        <p class="mb-1 mt-3 size-15 text-muted" *ngIf="speaker.role">{{ speaker.role }}</p>
                                        <h5 class="mb-2"><span class="font-weight-600">{{ speaker.name }}</span></h5>
                                        <p class="mb-2 size-15 text-muted" *ngIf="speaker.company">{{ speaker.company }}</p>
                                        <p class="mb-1" *ngIf="speaker.topic">Topic: {{ speaker.topic }}</p>
                                        <p class="mb-3 text-small text-muted" *ngIf="speaker.topicDescription">{{ speaker.topicDescription }}</p>
                                        <a *ngIf="speaker.videoUrl" [href]="speaker.videoUrl" class="glightbox btn-sm btn-dark animated m-2" data-type="video">
                                            Watch More <i class="uil uil-video size-22 m-2 pr-1"></i>
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>

    <!-- Event Committee (only shown when at least one member is configured) -->
    <div class="card border-0 landing-shadow-4 mb-4" *ngIf="(step === 'register' || step === 'readonly') && displayEventCommittee.length">
        <div class="card-body p-4">
            <h6 class="mb-3 color-primary">Event Committee</h6>
            <div #committeeSwiperContainer class="section swiper-team padding-bottom-40 swiper-container">
                <div class="swiper-wrapper">
                    <div class="swiper-slide" *ngFor="let member of displayEventCommittee">
                        <div class="leader-card text-center">
                            <img *ngIf="member.photoUrl" [src]="member.photoUrl" [alt]="member.name" class="img-fluid w-100 speaker-img">
                            <div *ngIf="!member.photoUrl" class="initials-avatar">{{ getInitials(member.name) }}</div>
                            <h6 class="mb-0 text-rana-primary mt-2">{{ member.name }}</h6>
                            <small class="text-muted text-sm" *ngIf="member.title">{{ member.title }}</small>
                            <p class="mt-2 text-small" *ngIf="member.shortDescription">{{ member.shortDescription }}</p>
                            <a *ngIf="member.videoUrl" [href]="member.videoUrl" class="glightbox btn btn-dark-primary animated m-2" data-type="video">
                                Watch More <i class="uil uil-video size-22 m-2 pr-1"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="swiper-pagination"></div>
            </div>
        </div>
    </div>

</ng-template>
